module.exports = __webpack_public_path__ + "media/images/happy-bus-62156fe93076eaac20ef18414a403cd4.png";